import {useFormContext, useWatch} from 'react-hook-form';
import {FORM_NAMES, FormTypes} from '../../utils/guestForm';
import {useSchema} from 'context/guest';
import {useEffect} from 'react';

function useValidatePreloadedFields() {
  const {setValue} = useFormContext<FormTypes>();
  const documentType = useWatch()[FORM_NAMES.document_type];
  const {formFields} = useSchema();

  useEffect(
    function validPreloadedDocumentType() {
      if (documentType && formFields[FORM_NAMES.document_type]?.options?.length) {
        const availableOptions = formFields[FORM_NAMES.document_type]?.options;
        const existingOption = availableOptions?.find(
          option => option.value === documentType.value,
        );

        if (!existingOption) {
          setValue(FORM_NAMES.document_type, undefined);
        }
      }
    },
    [formFields, documentType, setValue],
  );
}

export {useValidatePreloadedFields};
